import { render } from "./ComparasionPrice.vue?vue&type=template&id=f3290c52&scoped=true"
import script from "./ComparasionPrice.vue?vue&type=script&lang=js"
export * from "./ComparasionPrice.vue?vue&type=script&lang=js"

import "./ComparasionPrice.vue?vue&type=style&index=0&id=f3290c52&scoped=true&lang=css"
import "./ComparasionPrice.vue?vue&type=style&index=1&id=f3290c52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3290c52"]])

export default __exports__